import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var PaintRollerSVG = function PaintRollerSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M41,9a.781.781,0,0,0-.084.017c-.029,0-.054-.017-.084-.017H13.168c-.03,0-.055.015-.084.017A.781.781,0,0,0,13,9a1,1,0,0,0-1,1V25a1,1,0,0,0,1,1H33a.982.982,0,0,0,.388-.079,1.007,1.007,0,0,0,.533-.533A.982.982,0,0,0,34,25V23a1,1,0,0,1,2,0v4a1,1,0,0,0,2,0V23a1,1,0,0,1,2,0v6a1,1,0,0,0,2,0V10A1,1,0,0,0,41,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M25.567,26.989a1.293,1.293,0,0,0-1.286-1.132H22.147a1.294,1.294,0,0,0-1.286,1.132L20,34.343a3.217,3.217,0,0,0,6.429,0Zm-2.391,7.868a1.286,1.286,0,1,1,1.285-1.286A1.29,1.29,0,0,1,23.176,34.857Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__no-fill",
    x: "9.714",
    y: "6.571",
    width: "25.714",
    height: "7.714",
    rx: "2.571"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M20.861,26.989,20,34.343a3.217,3.217,0,0,0,6.429,0l-.862-7.354a1.293,1.293,0,0,0-1.286-1.132H22.147A1.294,1.294,0,0,0,20.861,26.989Zm2.319,5.3A1.286,1.286,0,1,1,21.9,33.571,1.288,1.288,0,0,1,23.18,32.286Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M23.18,34.857A1.286,1.286,0,1,0,21.9,33.571,1.288,1.288,0,0,0,23.18,34.857Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M32.857,4H12.286A5.141,5.141,0,0,0,7.143,9.143H5.857A3.869,3.869,0,0,0,2,13v5.143A3.869,3.869,0,0,0,5.857,22H20.643a1.29,1.29,0,0,1,1.286,1.286v.025a3.838,3.838,0,0,0-3.613,3.382l-.887,7.521a5.786,5.786,0,1,0,11.571,0l-.887-7.521A3.84,3.84,0,0,0,24.5,23.311v-.025a3.868,3.868,0,0,0-3.857-3.857H5.857a1.29,1.29,0,0,1-1.286-1.286V13a1.29,1.29,0,0,1,1.286-1.286H7.143a5.141,5.141,0,0,0,5.143,5.143H32.857A5.141,5.141,0,0,0,38,11.714V9.143A5.141,5.141,0,0,0,32.857,4Zm-7.29,22.989.862,7.354a3.217,3.217,0,0,1-6.429,0l.861-7.354a1.294,1.294,0,0,1,1.286-1.132h2.134A1.293,1.293,0,0,1,25.567,26.989Zm9.862-15.275a2.58,2.58,0,0,1-2.572,2.572H12.286a2.579,2.579,0,0,1-2.572-2.572V9.143a2.58,2.58,0,0,1,2.572-2.572H32.857a2.58,2.58,0,0,1,2.572,2.572Z"
  }));
};
PaintRollerSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
PaintRollerSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "PaintRoller")
};
export default withDetailedIcon(PaintRollerSVG);